export enum EditTabs {
    GENERAL = 'general',
    PERMISSIONS = 'users',
}
